import React from "react";

import "./Page404.sass";

function Page404() {
  return (
    <article className="page-not-found">
      <h2 className="page-not-found__title">404</h2>
      <strong className="page-not-found__sub-title">
        Oops, sorry we can’t find that page!
      </strong>
      <p className="page-not-found__text">
        Either something went wrong or the doesn’t exist anymore.
      </p>
    </article>
  );
}

export default Page404;
